import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/index";
import In_process from "@/components/in_process";
import Verfied_by_site from "@/components/verfied_by_site";
import Verfied_by_title from "@/components/verfied_by_title";
import Upload_excel from "@/components/upload_excel";
import Monitoring from "@/components/monitoring";
import Login from "@/components/login";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/",
      name: "Index",
      component: Index,
    },
    {
      path: "/in_process",
      name: "In_process",
      component: In_process,
    },
    {
      path: "/monitoring",
      name: "Monitoring",
      component: Monitoring,
    },
    {
      path: "/verfied_by_title",
      name: "Verfied_by_title",
      component: Verfied_by_title,
    },
    {
      path: "/verfied_by_site",
      name: "Verfied_by_site",
      component: Verfied_by_site,
    },
    {
      path: "/upload_excel",
      name: "Upload_excel",
      component: Upload_excel,
    },
  ],
});

// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === "/login") {
    next();
  } else {
    let token = localStorage.getItem("Authorization");
    console.log(token);
    if (token === null || token === "") {
      next("/login");
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js